module.exports = __webpack_public_path__ + "img/Stamp.1efd1140.png";